import { State } from '../../../cmsPage.widget'
import { OverviewState } from './overviewWidget.state'

const buildOverviewWidgetURL = (
    state: State,
    overviewState: OverviewState,
    reusePath: boolean,
    page?:number
): string => {
    let params: string[] = []

    if (state.CMSHeaderState?.searchState.searchValue) params.push(`searchQuery=${state.CMSHeaderState.searchState.searchValue}`)

    let searchParams = (new URL(window.location.href)).searchParams;

    let _pageSize = searchParams.get('pageSize')
    if(_pageSize == undefined || _pageSize == ""){
        _pageSize = `${overviewState.defaultPageSize}`
    }
    params.push(`page_size=${_pageSize}`)


    let _page = searchParams.get('page')
    if(_page == undefined || _page == ""){
        _page = `0`
    }
    params.push(`page=${page != undefined ? page : _page}`)

    let defaultPath = `/${window.location.href.includes("/wp/") ? "wp": ""}/zoeken`
        .replace(/\/\//g, "/")
        .replace(/\/\//g, "/")
    let path = defaultPath
    if (reusePath) {
        path = window.location.pathname
    }
    return `${params.length > 0 ? `${path}?${params.join("&")}` : ''}`

}

export const setWindowHistory = (state: State, overviewState: OverviewState, page?:number, reusePath: boolean = false) => {
    window.history.pushState({}, "", buildOverviewWidgetURL(state, overviewState, reusePath, page))
    var popStateEvent = new PopStateEvent('popstate', { state: {} });
    dispatchEvent(popStateEvent)
}

export const getUrlToCurrentState = (state: State, overviewState: OverviewState, page?:number, reusePath: boolean = false) : string => {
    return buildOverviewWidgetURL(state, overviewState, reusePath, page)
}
